module.exports = __webpack_public_path__ + "img/piscina.c6519b13.svg";